import PropTypes from 'prop-types';
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaginationInformation = _ref => {
  let {
    className = '',
    pageNumber,
    pageSize,
    totalItemCount
  } = _ref;
  const lowerBound = Math.min((pageNumber - 1) * pageSize + 1, totalItemCount);
  const upperBound = Math.min(pageNumber * pageSize, totalItemCount);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: ["Showing ", lowerBound, " - ", upperBound, " of ", totalItemCount]
  });
};
PaginationInformation.propTypes = {
  className: PropTypes.string,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
export default PaginationInformation;
//# sourceMappingURL=PaginationInformation.js.map